(function(){
/* VVC-CORE BEGIN — custom-size table core. SINGLE SOURCE: vivid-gallery-v1/scripts/pricing/vv-custom-core.cjs.
   Copied verbatim (by scripts/pricing/vvc-sync.cjs) into the theme calculators, the Cart Transform Function and the
   sales agent. Do not edit a copy — edit this file and re-sync. ES5 only (theme runs it untranspiled).
   T = { sheet:[2400,1200], reg:{ qs:[..], co:[[a,b,c,d],..] }, tail:[[q,m],..], sizes:[[L,S,[[q,rawEachEx],..]],..] }
   Returns Easy RAW each ex GST (before the -1% undercut, before options and before the minimum charge). */
function vvcLogInterp(p, x) {
  var n = p.length - 1, i, t;
  if (x <= p[0][0]) return p[0][1];
  if (x >= p[n][0]) return p[n][1];
  /* binary search: first i with p[i][0] >= x (same segment as a linear scan) */
  var lo = 1, hi = n, m;
  while (lo < hi) { m = (lo + hi) >> 1; if (p[m][0] >= x) hi = m; else lo = m + 1; }
  i = lo;
  t = (Math.log(x) - Math.log(p[i - 1][0])) / (Math.log(p[i][0]) - Math.log(p[i - 1][0]));
  return Math.exp(Math.log(p[i - 1][1]) + t * (Math.log(p[i][1]) - Math.log(p[i - 1][1])));
}
function vvcEff(T, L, S) {
  var SW = T.sheet[0], SH = T.sheet[1], best = -1, n, e;
  n = Math.floor(SH / S); if (n >= 1 && L <= SW) best = L * (SH / n) / 1e6;
  n = Math.floor(SH / L); if (n >= 1 && S <= SW) { e = S * (SH / n) / 1e6; if (best < 0 || e < best) best = e; }
  return best < 0 ? L * S / 1e6 : best;
}
function vvcRegAt(T, L, S, i) {
  var c = T.reg.co[i];
  return c[0] * (L * S / 1e6) + c[1] * vvcEff(T, L, S) + c[2] * (2 * (L + S) / 1000) + c[3];
}
/* regression prediction at q, q clamped into the fitted range; log-log between bracketing grid points */
function vvcReg(T, L, S, q) {
  var qs = T.reg.qs, n = qs.length - 1, i, a, b;
  if (q <= qs[0]) return vvcRegAt(T, L, S, 0);
  if (q >= qs[n]) return vvcRegAt(T, L, S, n);
  for (i = 1; i <= n; i++) if (qs[i] >= q) {
    a = vvcRegAt(T, L, S, i - 1); b = vvcRegAt(T, L, S, i);
    if (a > 0 && b > 0) return vvcLogInterp([[qs[i - 1], a], [qs[i], b]], q);
    return a + (b - a) * (q - qs[i - 1]) / (qs[i] - qs[i - 1]);
  }
  return vvcRegAt(T, L, S, n);
}
function vvcTail(T, q0, q) { return vvcLogInterp(T.tail, q) / vvcLogInterp(T.tail, q0); }
/* one captured size: its own points; past its last captured quantity it follows the regression's own quantity
   shape for that size (inside the fitted range) and then the tail curve */
/* a size row's points; the Function ships each row as a function returning its literal, so only the rows a cart
   actually needs are ever built (instruction budget) */
function vvcPts(r) {
  var a, p, i;
  /* Function copy: a flat array of integers [q, v*1e5, q, v*1e5, ...] (integer literals are inline in QuickJS
     bytecode; doubles would each be a constant-pool entry deserialised at every start) */
  if (typeof r[2] === 'function') { a = r[2](); p = []; for (i = 0; i + 1 < a.length; i += 2) p.push([a[i], a[i + 1] / 1e5]); r[2] = p; }
  return r[2];
}
function vvcRefRaw(T, r, q) {
  var p = vvcPts(r), last = p[p.length - 1], hi = T.reg.qs[T.reg.qs.length - 1], q0 = last[0], v = last[1], a, b;
  if (q <= q0) return vvcLogInterp(p, q);
  if (q0 < hi) { a = vvcReg(T, r[0], r[1], q0); b = vvcReg(T, r[0], r[1], Math.min(q, hi));
    if (a > 0 && b > 0) v = v * b / a; q0 = Math.min(q, hi); }
  return q > q0 ? v * vvcTail(T, q0, q) : v;
}
function vvcNearest(T, L, S) {
  var X = vvcIdx(T), R = X.R, F = X.F, x0 = Math.log(L * S / 1e6), x1 = Math.log(vvcEff(T, L, S)), x2 = Math.log(L / S), best = null, bd = 1e99, lo = 0, hi = R.length - 1, m, i, j, f, a, b, c, d;
  /* rows are sorted by area: start at the area neighbour and walk outwards while the area term alone can still beat
     the best distance (exact same answer as a full scan, a handful of rows instead of all of them) */
  while (lo < hi) { m = (lo + hi) >> 1; if (F[m][0] >= x0) hi = m; else lo = m + 1; }
  for (j = 0; j < 2; j++) for (i = (j ? lo - 1 : lo); i >= 0 && i < R.length; i += (j ? -1 : 1)) {
    f = F[i]; a = x0 - f[0]; if (a * a >= bd) break;
    b = x1 - f[1]; c = x2 - f[2]; d = a * a + b * b + 0.25 * c * c;
    if (d < bd) { bd = d; best = R[i]; } }
  return best;
}
/* one-time per-table index. The build ships it precomputed (T.ix, rows already sorted by area, T._f features) so the
   Function does no index work at all (instruction budget); the theme/agent/tools compute it once here otherwise.
   k = sorted exact-size keys (L*4096+S), ki = their row numbers, A = [[area, [row numbers]], ...] ascending. */
function vvcIdx(T) {
  var X, i, r, R = T.sizes, K = [], A = [], n, k, F;
  if (T._x) return T._x;
  if (T.ix && T._f) {
    F = T._f;
    if (typeof F === 'function') { k = F(); F = []; for (i = 0; i + 2 < k.length; i += 3) F.push([k[i] / 1e6, k[i + 1] / 1e6, k[i + 2] / 1e6]); T._f = F; }
    T._x = { R: R, F: F, k: T.ix.k, ki: T.ix.ki, A: T.ix.A }; return T._x; }
  for (i = 1; i < R.length; i++) if (R[i][0] * R[i][1] < R[i - 1][0] * R[i - 1][1]) { R = R.slice().sort(function (x, y) { return x[0] * x[1] - y[0] * y[1]; }); break; }
  F = (R === T.sizes && T._f) ? T._f : [];
  for (i = 0; i < R.length; i++) { r = R[i];
    if (F !== T._f) F.push([Math.log(r[0] * r[1] / 1e6), Math.log(vvcEff(T, r[0], r[1])), Math.log(r[0] / r[1])]);
    K.push([r[0] * 4096 + r[1], i]); k = r[0] * r[1];
    n = A.length; if (n && A[n - 1][0] === k) A[n - 1][1].push(i); else A.push([k, [i]]); }
  K.sort(function (x, y) { return x[0] - y[0]; });
  X = { R: R, F: F, k: [], ki: [], A: A };
  for (i = 0; i < K.length; i++) { X.k.push(K[i][0]); X.ki.push(K[i][1]); }
  T._x = X; return X;
}
function vvcFind(X, key) {
  var lo = 0, hi = X.k.length - 1, m;
  while (lo < hi) { m = (lo + hi) >> 1; if (X.k[m] >= key) hi = m; else lo = m + 1; }
  return X.k[lo] === key ? X.R[X.ki[lo]] : null;
}
function vvcCustomRaw(T, w, h, q) {
  var L = Math.max(w, h), S = Math.min(w, h), X = vvcIdx(T), r, qs = T.reg.qs, lo = qs[0], hi = qs[qs.length - 1], v, dl, ds;
  r = vvcFind(X, L * 4096 + S); if (r) return vvcRefRaw(T, r, q);
  for (dl = -1; dl <= 1; dl++) for (ds = -1; ds <= 1; ds++) { r = vvcFind(X, (L + dl) * 4096 + S + ds); if (r) return vvcRefRaw(T, r, q); }
  /* smaller than every captured size: price as the smallest captured size (never cheaper) */
  if (L * S <= X.A[0][0]) return vvcRefRaw(T, X.R[X.A[0][1][0]], q);
  if (q < lo) { r = vvcNearest(T, L, S); v = vvcReg(T, L, S, lo) * vvcRefRaw(T, r, q) / vvcRefRaw(T, r, lo); }
  else if (q > hi) v = vvcReg(T, L, S, hi) * vvcTail(T, hi, q);
  else v = vvcReg(T, L, S, q);
  /* regression is only trusted while positive; otherwise scale the nearest captured size by area */
  if (!(v > 0)) { r = vvcNearest(T, L, S); v = vvcRefRaw(T, r, q) * (L * S) / (r[0] * r[1]); }
  /* T.floorArea (ACP "never below Easy"): never under straight area-interpolation between captured neighbours */
  if (T.floorArea) v = Math.max(v, vvcAreaInterp(T, L * S, q));
  return v;
}
/* straight interpolation in area between the captured sizes just below and just above (max over equal areas) */
function vvcAreaInterp(T, a, q) {
  var X = vvcIdx(T), A = X.A, i, j, lo = 0, hi = 0, e, lA, hA, t, b = 0, c = A.length - 1, m;
  /* last i with A[i][0] <= a (or 0) */
  while (b < c) { m = (b + c + 1) >> 1; if (A[m][0] <= a) b = m; else c = m - 1; }
  i = b;
  lA = A[i]; hA = A[i][0] >= a ? A[i] : (i + 1 < A.length ? A[i + 1] : A[i]);
  for (j = 0; j < lA[1].length; j++) { e = vvcRefRaw(T, X.R[lA[1][j]], q); if (e > lo) lo = e; }
  for (j = 0; j < hA[1].length; j++) { e = vvcRefRaw(T, X.R[hA[1][j]], q); if (e > hi) hi = e; }
  if (hA === lA) return (a > hA[0] ? hi * a / hA[0] : hi);
  t = (a - lA[0]) / (hA[0] - lA[0]); return lo + t * (hi - lo);
}
/* Easy multi-design artwork fee (raw ex) for D designs; linear between captured D, flat past the last */
function vvcDesignFee(F, d) {
  var i, t;
  if (!F || !F.length || d < 2) return 0;
  if (d <= F[0][0]) return F[0][1];
  for (i = 1; i < F.length; i++) if (F[i][0] >= d) { t = (d - F[i - 1][0]) / (F[i][0] - F[i - 1][0]); return F[i - 1][1] + t * (F[i][1] - F[i - 1][1]); }
  return F[F.length - 1][1];
}
/* VVC-CORE END */

  var CFG; try{ CFG=JSON.parse(document.getElementById('vcorf-cfg').textContent); }catch(e){ return; }
  /* Owner overrides from shop metafield vivid.calculator_pricing (edited in the
     Tier Pricing app). Same merge rules + sanity bounds as the Function, so the
     page ALWAYS shows what checkout will charge. Malformed -> defaults. */
  try{
    var ovEl=document.getElementById('vcorf-overrides');
    var ovAll=ovEl?JSON.parse(ovEl.textContent):null;
    var ov=ovAll&&ovAll.corflute;
    if(ov&&typeof ov==='object'){
      var num=function(v){var n=Number(v);return (isFinite(n)&&n>0)?n:null;};
      var mc=num(ov.minChargeEx); if(mc!=null)CFG.minChargeEx=mc;
      var uc=num(ov.undercut); if(uc!=null&&uc>=0.5&&uc<=1.5)CFG.undercut=uc;
      if(ov.presetsQ100&&typeof ov.presetsQ100==='object'){for(var k in ov.presetsQ100){var v=num(ov.presetsQ100[k]);if(v!=null)CFG.presetsQ100[k]=v;}}
      if(ov.modifiers&&typeof ov.modifiers==='object'){
        var pe=num(ov.modifiers.perEyeletEx); if(pe!=null)CFG.modifiers.perEyeletEx=pe;
        var ds=num(ov.modifiers.doubleSidedMult); if(ds!=null)CFG.modifiers.doubleSidedMult=ds;
        var t3=num(ov.modifiers.thickness3mmMult); if(t3!=null)CFG.modifiers.thickness3mmMult=t3;
        var cc=Number(ov.modifiers.customContourAddEx); if(isFinite(cc)&&cc>=0)CFG.modifiers.customContourAddEx=cc;
      }
      if(ov.unavailable&&typeof ov.unavailable==='object'){
        if(typeof ov.unavailable.thickness3mm==='boolean')CFG.unavailable.thickness3mm=ov.unavailable.thickness3mm;
        if(typeof ov.unavailable.doubleSided==='boolean')CFG.unavailable.doubleSided=ov.unavailable.doubleSided;
      }
      if(ov.custom&&typeof ov.custom==='object'){
        var fp=num(ov.custom.fixedPerSign); if(fp!=null)CFG.custom.fixedPerSign=fp;
        var pm=num(ov.custom.perM2); if(pm!=null)CFG.custom.perM2=pm;
        var pp=Number(ov.custom.premiumPct); if(isFinite(pp)&&pp>=0&&pp<1)CFG.custom.premiumPct=pp;
      }
      if(Array.isArray(ov.qtyBreaks)&&ov.qtyBreaks.length>=2){
        var qb=[],ok=true;
        for(var i2=0;i2<ov.qtyBreaks.length;i2++){var r2=ov.qtyBreaks[i2];
          if(!Array.isArray(r2)||r2.length!==2||num(r2[0])==null||num(r2[1])==null){ok=false;break;}
          qb.push([Math.floor(Number(r2[0])),Number(r2[1])]);}
        if(ok){qb.sort(function(x,y){return x[0]-y[0];});CFG.qtyBreaks=qb;
          /* #86: qtyBreaks is the pre-per-size knob. An owner who sets it is taking manual
             control of the whole model, so honour that on every size (old semantics). Use
             qtyCurves below to steer one size only. */
          if(CFG.qtyCurves){for(var ck in CFG.qtyCurves)CFG.qtyCurves[ck]=qb;}}
      }
      /* #86: per-size curve overrides - { "qtyCurves": { "small": [[10,2.55],...] } } */
      if(ov.qtyCurves&&typeof ov.qtyCurves==='object'&&CFG.qtyCurves){
        for(var cn in ov.qtyCurves){ var src=ov.qtyCurves[cn];
          if(!Array.isArray(src)||src.length<2)continue;
          var cb=[],cok=true;
          for(var i3=0;i3<src.length;i3++){var r3=src[i3];
            if(!Array.isArray(r3)||r3.length!==2||num(r3[0])==null||num(r3[1])==null){cok=false;break;}
            cb.push([Math.floor(Number(r3[0])),Number(r3[1])]);}
          if(cok){cb.sort(function(x,y){return x[0]-y[0];});CFG.qtyCurves[cn]=cb;}
        }
      }
      /* 30-Sep Option 1b: sizeCurve override - point a PRESET label at a named curve that exists in
         qtyCurves (compiled or overridden), e.g. {"sizeCurve":{"600mm W x 900mm H":"medium"}} rolls the
         dense preset curve back to the old one without a code push. Custom sizes resolve by area against
         small/medium/large and are never affected. Unknown curve names are ignored. Mirrors the Function. */
      if(ov.sizeCurve&&typeof ov.sizeCurve==='object'&&CFG.sizeCurve&&CFG.qtyCurves){
        for(var sk in ov.sizeCurve){ var sv=ov.sizeCurve[sk]; if(typeof sv==='string'&&Array.isArray(CFG.qtyCurves[sv])) CFG.sizeCurve[sk]=sv; }
      }
    }
  }catch(e){}
  /* GOLIVE-V2 (30-Sep) — DORMANT until shop metafield vivid.calculator_pricing has corflute.v2 === true (an unpublished
     preview theme injects the activation itself). Custom sizes are priced from the Easy Signflute(TM) custom-size table
     (#vcorf-table — the same table the Cart Transform Function compiles, maths in the VVC core above), and several
     designs of ONE configuration are priced as one order of the total quantity + Easy's artwork fee; the Function groups
     the design lines exactly the same way, so page = cart = checkout. */
  var V2=false, VT=null;
  try{ var ovA=JSON.parse((document.getElementById('vcorf-overrides')||{}).textContent||'null'); V2=!!(ovA&&ovA.corflute&&ovA.corflute.v2===true); }catch(e){}
  try{ VT=JSON.parse(document.getElementById('vcorf-table').textContent); }catch(e){ VT=null; }
  if(!VT) V2=false;
  var root=document.getElementById('vcorf'); if(!root) return;
  var money=function(n){ return '$'+n.toFixed(2); };
  // 19-Aug (docs/06): when ITORIS DPO is gone (post-flip), nothing calls vvdReveal and the
  // settle curtain sits until its 9s failsafe. The calculator is ready as soon as it boots —
  // reveal early. No-op while DPO is installed (its kicker reveals as today).
  setTimeout(function(){ try{ if(!window.dpoOptions && window.vvdReveal) window.vvdReveal(); }catch(e){} }, 1800);
  var state={ size:CFG.presets[1].label, custom:false, w:null, h:null, thickness:5, printing:1, eyelets:0, cutting:'Standard', qty:10, designs:1 };

  function card(nm,sub,rec){ var c=document.createElement('button'); c.type='button'; c.className='vcorf-card';
    c.innerHTML='<span class="vcorf-nm">'+nm+'</span>'+(sub?'<span class="vcorf-sub">'+sub+'</span>':'')+(rec?'<span class="vcorf-rec">POPULAR</span>':''); return c; }
  function setOn(grp,el){ [].forEach.call(root.querySelectorAll('[data-grp="'+grp+'"] .vcorf-card'),function(x){x.classList.remove('on');}); if(el)el.classList.add('on'); }

  // SIZE cards
  var sizeGrp=root.querySelector('[data-grp="size"]'), custWrap=root.querySelector('[data-cust]');
  /* #86: the "from" price is the best (max-qty) rate for THAT size, so it has to use that
     size's own curve - using the shared default quoted 600x450 from $3.72 when its real
     floor is $3.54, and every other size off its own curve too. */
  function fromCurve(label){ var n=CFG.sizeCurve&&CFG.sizeCurve[label];
    return (n&&CFG.qtyCurves&&CFG.qtyCurves[n])||CFG.qtyBreaks; }
  CFG.presets.forEach(function(p){ var fc=fromCurve(p.label);
    var c=card(p.label.replace(/mm W x /,' × ').replace(/mm H/,'mm'), 'from '+money(CFG.presetsQ100[p.label]*fc[fc.length-1][1]*CFG.gst), p.rec);
    if(p.label===state.size)c.classList.add('on');
    c.addEventListener('click',function(){ state.custom=false; state.size=p.label; setOn('size',c); custWrap.classList.remove('show'); recalc(); });
    sizeGrp.appendChild(c);
  });
  var customCard=card('Custom size','any W × H');
  customCard.addEventListener('click',function(){ state.custom=true; setOn('size',customCard); custWrap.classList.add('show'); recalc(); });
  sizeGrp.appendChild(customCard);
  root.querySelector('[data-w]').addEventListener('input',function(){ state.w=(CFG.custom.rotate ? Number(this.value) : parseInt(this.value,10))||null; recalc(); });
  root.querySelector('[data-h]').addEventListener('input',function(){ state.h=(CFG.custom.rotate ? Number(this.value) : parseInt(this.value,10))||null; recalc(); });

  // THICKNESS / PRINTING / CUTTING cards
  function simpleCards(grp,items,onPick){ var g=root.querySelector('[data-grp="'+grp+'"]');
    items.forEach(function(it,i){ var c=card(it.nm,it.sub);
      if(it.off){
        /* Unavailable: greyed, never selectable, and it says so ON THE CARD. It must never
           reach onPick - otherwise state.thickness/printing would change and the customer
           would be quoted for something we cannot make.

           26-Aug, second pass: the first version said "unavailable" ONLY in a hover
           tooltip. There is no hover on a phone or a tablet, so on touch the card was
           just greyed with no reason given - and the owner reported exactly that on
           Double Sided. The reason now sits in the card's own sub-line, visible to
           everyone; the tooltip stays as a desktop nicety, not as the only carrier of
           the message. */
        var sb=c.querySelector('.vcorf-sub');
        if(sb){ sb.textContent='Currently unavailable'; }
        else { var ns=document.createElement('span'); ns.className='vcorf-sub'; ns.textContent='Currently unavailable'; c.appendChild(ns); }
        c.classList.add('off'); c.setAttribute('aria-disabled','true');
        c.setAttribute('data-msg', it.offMsg || 'Currently unavailable');
        c.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); });
        g.appendChild(c); return;
      }
      if(i===0)c.classList.add('on');
      c.addEventListener('click',function(){ setOn(grp,c); onPick(it.val); recalc(); }); g.appendChild(c); }); }
  simpleCards('thickness',[
    {nm:'5mm',sub:'standard',val:5},
    {nm:'3mm',sub:'lighter/cheaper',val:3,off:CFG.unavailable&&CFG.unavailable.thickness3mm,offMsg:'3mm is currently unavailable'}
  ],function(v){state.thickness=v;});
  simpleCards('printing',[
    {nm:'Single Sided',val:1},
    {nm:'Double Sided',val:2,off:CFG.unavailable&&CFG.unavailable.doubleSided,offMsg:'Double sided is currently unavailable'}
  ],function(v){state.printing=v;});
  simpleCards('cutting',[{nm:'Standard',sub:'rectangular',val:'Standard'},{nm:'Custom Contour',sub:'cut to shape',val:'Custom Contour'}],function(v){state.cutting=v;});

  // EYELETS select
  var eyeSel=root.querySelector('[data-grp="eyelets"]');
  CFG.eyelets.forEach(function(e){ var o=document.createElement('option'); o.value=e.n; o.textContent=e.label; eyeSel.appendChild(o); });
  eyeSel.addEventListener('change',function(){ state.eyelets=parseInt(this.value,10)||0; recalc(); });

  // QUANTITY
  var qtyInput=root.querySelector('[data-qty]');
  qtyInput.addEventListener('input',function(){ state.qty=Math.max(1,parseInt(this.value,10)||1); syncChips(); recalc(); });
  var chipWrap=root.querySelector('[data-qtychips]');
  /* 22-Aug: 1 added to the ladder (owner). Corflute is bought in bulk and the
     ladder started at 10, so a customer who wanted a single sign had to ignore
     the chips and type into the box. Quantity 1 always trips the minimum
     charge — that is expected, and the minimum-order bar below now explains it
     instead of letting the price look arbitrary. */
  [1,10,25,50,100,250,500].forEach(function(q){ var s=document.createElement('button'); s.type='button'; s.className='vcorf-chip'; s.textContent=q; s.dataset.q=q;
    s.addEventListener('click',function(){ state.qty=q; qtyInput.value=q; syncChips(); recalc(); }); chipWrap.appendChild(s); });
  function syncChips(){ [].forEach.call(chipWrap.children,function(s){ s.classList.toggle('on', +s.dataset.q===state.qty); }); }
  /* v2: number of different designs (same size + options). Each design becomes its own cart line (its own artwork
     upload); the total quantity is split across them and priced as one order. */
  var dsgSel=null;
  if(V2){ var dsgWrap=document.createElement('div'); dsgWrap.className='vcorf-designs'; dsgWrap.style.display='none'; /* 1-Oct owner: picker hidden */
    dsgWrap.innerHTML='<label style="display:flex;gap:10px;align-items:center;margin-top:10px;font-weight:600;font-size:14px">Different designs <select data-designs style="padding:6px 10px;border:1px solid #ccc;border-radius:6px;font-size:14px"></select></label><small style="display:block;opacity:.75;margin-top:4px;font-size:12.5px;line-height:1.4">Same size and options, different artwork: priced as one order of the total quantity plus a small artwork fee for each extra design. Each design gets its own cart line and artwork upload.</small>';
    var qRow=root.querySelector('.vcorf-qty'); if(qRow&&qRow.parentNode) qRow.parentNode.insertBefore(dsgWrap,qRow.nextSibling); else root.appendChild(dsgWrap);
    dsgSel=dsgWrap.querySelector('[data-designs]');
    dsgSel.addEventListener('change',function(){ state.designs=parseInt(this.value,10)||1; recalc(); }); }
  function syncDesigns(){ if(!dsgSel) return; var mx=Math.max(1,Math.min(10,state.qty)); if(state.designs>mx) state.designs=mx;
    var h=''; for(var d=1;d<=mx;d++) h+='<option value="'+d+'"'+(d===state.designs?' selected':'')+'>'+d+'</option>'; dsgSel.innerHTML=h; }

  // PRICING
  /* 24-Aug bug #86: the quantity curve is now chosen PER SIZE (see _qtyCurves_note in the
     config). Presets map by label; a custom size takes the curve of the nearest preset BY
     AREA, which is the property the discount actually tracks. Anything unmapped falls back
     to CFG.qtyBreaks - identical to the old single-curve behaviour, so this can never make
     a price worse than it was. */
  function curveFor(){
    try{
      if(!state.custom){ var n=CFG.sizeCurve&&CFG.sizeCurve[state.size];
        if(n&&CFG.qtyCurves&&CFG.qtyCurves[n])return CFG.qtyCurves[n]; }
      else if(CFG.curveAreaM2&&CFG.qtyCurves&&state.w&&state.h){
        var a=(state.w/1000)*(state.h/1000), best=null, bd=Infinity;
        for(var k in CFG.curveAreaM2){ var d=Math.abs(CFG.curveAreaM2[k]-a);
          if(d<bd&&CFG.qtyCurves[k]){ bd=d; best=CFG.qtyCurves[k]; } }
        if(best)return best;
      }
    }catch(e){}
    return CFG.qtyBreaks;
  }
  function qtyMult(q,b){ b=b||curveFor(); if(q<=b[0][0])return b[0][1]; if(q>=b[b.length-1][0])return b[b.length-1][1];
    for(var i=0;i<b.length-1;i++){ if(q>=b[i][0]&&q<=b[i+1][0]){ var t=(q-b[i][0])/(b[i+1][0]-b[i][0]); return b[i][1]+(b[i+1][1]-b[i][1])*t; } } return 1; }
  function baseQ100(){ if(state.custom){ if(!validCustom())return null; var area=(state.w/1000)*(state.h/1000);
      return (CFG.custom.fixedPerSign + CFG.custom.perM2*area)*(1+CFG.custom.premiumPct)*CFG.undercut; }
    return CFG.presetsQ100[state.size]; }
  function validCustom(){ var mn=CFG.custom.minMM, mx=CFG.custom.maxMM;
    if(CFG.custom.rotate) return Number.isInteger(state.w)&&Number.isInteger(state.h)&&Math.min(state.w,state.h)>=Math.min(mn[0],mn[1])&&Math.max(state.w,state.h)<=Math.max(mx[0],mx[1])&&Math.min(state.w,state.h)<=Math.min(mx[0],mx[1]);
    return state.w&&state.h&&state.w>=mn[0]&&state.h>=mn[1]&&state.w<=mx[0]&&state.h<=mx[1]; }
  /* 22-Aug: the per-sign price at a GIVEN quantity, before the minimum-charge
     floor. Lifted out of compute() unchanged — compute() used to inline this
     against state.qty only, but the minimum-order message has to ask what the
     price would be at OTHER quantities, which needs it as a function. */
  /* v2: a custom size whose label IS a standard preset (same orientation) is priced as that preset — exactly what the
     Function does (its preset lookup is by label) */
  function presetLabelOf(){ if(!state.custom) return state.size; var l=state.w+'mm W x '+state.h+'mm H'; return (CFG.presetsQ100[l]!=null)?l:null; }
  function eachExAt(q){ var base=baseQ100(); if(base==null)return null;
    var each;
    if(V2&&state.custom){ var pl=presetLabelOf();
      if(pl){ var n2=CFG.sizeCurve&&CFG.sizeCurve[pl]; each=CFG.presetsQ100[pl]*qtyMult(q,(n2&&CFG.qtyCurves&&CFG.qtyCurves[n2])||CFG.qtyBreaks); }
      else each=vvcCustomRaw(VT,state.w,state.h,q)*CFG.undercut; }
    else each=base*qtyMult(q);
    if(state.printing===2)each*=CFG.modifiers.doubleSidedMult;
    if(state.thickness===3)each*=CFG.modifiers.thickness3mmMult;
    each+=CFG.modifiers.perEyeletEx*state.eyelets;
    if(state.cutting==='Custom Contour')each+=CFG.modifiers.customContourAddEx;
    return each; }
  /* The most signs the customer can have for money they are already committed
     to: the largest quantity whose un-floored total still sits at or under the
     minimum charge. The line total rises monotonically with q — the unit price
     falls, but never fast enough to outrun the count — so a forward scan with
     an early break is exact, not an approximation. Capped at the last
     rate-curve anchor so a malformed config cannot spin this loop. */
  function sameMoneyQty(){ var b=curveFor(), cap=b[b.length-1][0], best=state.qty; /* #86: cap from the ACTIVE curve */
    for(var q=state.qty+1;q<=cap;q++){ var e=eachExAt(q); if(e==null)break;
      if(e*q<=CFG.minChargeEx)best=q; else break; }
    return best; }
  function compute(){ var each=eachExAt(state.qty); if(each==null)return null;
    var rawEx=each*state.qty;
    var lineEx=Math.max(CFG.minChargeEx, rawEx);
    var minHit=rawEx<CFG.minChargeEx;
    // CFG is EX GST. Everything shown to the customer, and the price the Cart Transform
    // Function enforces, is INC GST — the shop is tax-inclusive. See docs/11.
    /* 30-Sep (pricing audit): show exactly what checkout charges. The Cart Transform Function sets a
       per-unit price rounded to the cent, and the cart total is that x qty - so the page total is the
       rounded unit x qty too (e.g. 20 x $8.77 = $175.40, not $175.33). */
    /* v2 multi-design: + Easy's artwork fee for the number of designs, spread over the total quantity — the Function's
       exact expression ((lineEx/Q)*Q + fee)/Q */
    var feeEx=(V2&&state.designs>1)?vvcDesignFee(VT.designFee,state.designs)*CFG.undercut:0;
    var unitEx=feeEx?(((lineEx/state.qty)*state.qty+feeEx)/state.qty):lineEx/state.qty;
    var eachIncR=+(unitEx*CFG.gst).toFixed(2); /* the Function's exact expression: fixedPricePerUnit = (eachEx*GST).toFixed(2) - Math.round differs on half-cent ties (600x450 q100: 5.33 vs 5.34) */
    return { eachEx:unitEx, lineEx:lineEx+feeEx, feeEx:feeEx, eachInc:eachIncR, lineInc:Math.round(eachIncR*state.qty*100)/100,
             minHit:minHit, sameFor:minHit?sameMoneyQty():state.qty }; }

  var eachEl=root.querySelector('[data-each]'), totEl=root.querySelector('[data-total]'),
      minEl=root.querySelector('[data-mincharge]'), curSize=root.querySelector('[data-cur="size"]'),
      addBtn=root.querySelector('[data-add]'), noteEl=root.querySelector('[data-note]'),
      custHint=root.querySelector('[data-custhint]'), minBar=root.querySelector('[data-minbar]');
  // The product-page CTAs have their own legacy handlers outside the calculator.
  // Stop invalid Corflute selections before those handlers can open an order flow.
  if(CFG.custom.rotate) document.addEventListener('click',function(e){
    var target=e.target&&e.target.closest?e.target:null; if(!target)return;
    var quoteLink=target.closest('#vcorf [data-custhint] a');
    if(quoteLink){
      e.preventDefault(); e.stopImmediatePropagation();
      window.location.assign(quoteLink.href);
      return;
    }
    if(!target.closest('.vvbc-cta,.vv-cta,[data-add]') || !state.custom || validCustom())return;
    e.preventDefault(); e.stopImmediatePropagation();
    recalc();
    custHint.setAttribute('role','alert');
    custHint.scrollIntoView({block:'center',behavior:'smooth'});
  },true);
  /* One tap from "you are paying the minimum" to "then take the full amount of
     signs it buys". Delegated because the button is re-rendered on every
     recalc. */
  if(minBar) minBar.addEventListener('click',function(e){
    var b=e.target&&e.target.closest?e.target.closest('[data-minjump]'):null; if(!b)return;
    state.qty=parseInt(b.getAttribute('data-minjump'),10)||state.qty;
    qtyInput.value=state.qty; syncChips(); recalc(); });
  /* 24-Aug — "two banners, one artwork" note, calculator panel. Same problem as the tile panel:
     a quantity is ONE design, and nothing said so until the artwork step. Same shared markup,
     CSS and wording (snippets/vivid-multi-design-note.liquid) so the two panel types can never
     diverge. Mounted directly above the quantity row, under the "Quantity" label.
     DISPLAY ONLY — it reads state.qty, which is already computed; it cannot move a price. */
  var vvMultiNote = (window.__vvMulti && root.querySelector('.vcorf-qty'))
    ? window.__vvMulti.mount(root.querySelector('.vcorf-qty')) : null;

  function recalc(){
    /* First thing in recalc, BEFORE the early return below — the note must stay correct even
       when the size is incomplete and no price can be computed. Blank/0 counts as 1 (hidden). */
    if(vvMultiNote) window.__vvMulti.set(vvMultiNote, state.qty);
    syncDesigns();
    curSize.textContent = state.custom ? (validCustom()? state.w+' × '+state.h+'mm' : 'enter size') : state.size.replace(/mm W x /,' × ').replace(/mm H/,'mm');
    if(state.custom && !validCustom()){ custHint.classList.add('vcorf-err'); }
    else { custHint.classList.remove('vcorf-err'); }
    var r=compute();
    if(!r){ eachEl.textContent='—'; totEl.textContent='—'; minEl.textContent='';
      if(minBar){minBar.hidden=true;minBar.innerHTML='';} addBtn.disabled=true;
      try{ window.vvCalcLine={model:'corflute',valid:false,props:null}; }catch(e){}
      return; }
    addBtn.disabled=false;
    eachEl.innerHTML=money(r.eachInc)+' <small>ea</small>';
    totEl.textContent=money(r.lineInc);
    /* Release-hardening (2026-10-06; ports the 3-Oct fix that never reached the live theme) — publish the
       current line-item props so the design journey (VividCanvas finish, the AI designer's ?cfg=) carries the
       SAME user-selected size/options onto a designed line. Reads already-computed state; cannot move a price. */
    try{ var vvPub=vvBuildProps(r); delete vvPub.__vvD; window.vvCalcLine={model:'corflute',valid:true,props:vvPub}; }catch(e){}
    /* 22-Aug (owner). The old message was the bare words "minimum order
       applied", tucked under the total. It never named the amount, so someone
       who arrived on "from $7.58", asked for one sign and saw $136.13 had no
       way to understand the jump — the price just looked wrong, and the only
       place it got explained was the cart.
       Now: name the figure, and turn the dead end into the useful next step.
       At these quantities the floor IS the whole price, so the honest and
       persuasive thing are the same sentence — the money is already spent, and
       this says how many signs it actually buys. */
    minEl.textContent='';
    if(minBar){
      if(r.minHit){
        var msg='<b>'+money(CFG.minChargeEx*CFG.gst)+' minimum order applies.</b>';
        if(r.sameFor>state.qty){
          msg+='<em>'+r.sameFor+' signs cost you the same — '+
               '<button type="button" data-minjump="'+r.sameFor+'">make it '+r.sameFor+'</button></em>';
        }
        minBar.innerHTML=msg; minBar.hidden=false;
      } else { minBar.hidden=true; minBar.innerHTML=''; }
    }
    noteEl.textContent = (V2&&state.designs>1) ? ('Includes '+money(r.feeEx*CFG.gst)+' artwork fee for '+state.designs+' designs — they go in the cart as '+state.designs+' lines, one upload each.')
      : (state.custom ? (V2 ? '' : 'Custom size priced per m². Presets are cheaper — pick a preset above if one fits.') : '');
  }

  // Build the calculator's line-item properties from the CURRENT selection (extracted so the design
  // journey can carry the SAME user-selected size/options onto a designed line; published on every
  // recalc() via window.vvCalcLine and read by vivid-cc-app.js / the product-page design-entry gate).
  function vvBuildProps(r){
    var props={
      'Size': state.custom ? (state.w+'mm W x '+state.h+'mm H (Custom)') : state.size,
      'Thickness': state.thickness+'mm - Corrugated Plastic',
      'Printing': state.printing===2?'Double Sided':'Single Sided',
      'Eyelets': (eyeSel.options[eyeSel.selectedIndex]||{}).text || 'No Eyelets',
      'Cutting': state.cutting,
      '_vcorf_price_ex': r.eachEx.toFixed(2),
      '_vcorf_line_ex': r.lineEx.toFixed(2)
    };
    /* 01-Sep — PRODUCTION PROPERTIES. This calculator replaced the ITORIS DPO block and
       builds its property list from scratch, so nothing in hidden_fields.liquid ever
       reached the cart. Measured: 0 of 57 corflute / foam / fabric line items since
       22-Aug carried _Bubble_Printer_Name, against 434 in the year before. Switch had
       no printer, no product type, no flow type, no material to route on.
       Sweep them off the form that is ALREADY on this page — every value comes from the
       product's own metafields, nothing is computed or guessed here. */
    try{
      /* Skip the size-dependent fields — hidden_fields renders a STATIC default for these,
         which has nothing to do with the size the customer just configured. They are set
         explicitly below from this calculator's own figures. */
      var vvSkip={'_Standardized_Width':1,'_Standardized_Height':1,'_TOTAL_SQM':1,'_TOTAL_SHEET':1,'_PRODUCT_TITLE':1,'_Standardized_Sided':1};
      document.querySelectorAll('form[action*="/cart/add"] input[name^="properties["]').forEach(function(inp){
        var k=inp.name.slice(11,-1);
        if(k && !vvSkip[k] && props[k]===undefined && String(inp.value||'').trim()!=='') props[k]=inp.value;
      });
    }catch(e){}
    /* The SIZE-dependent fields are the ones hidden_fields leaves blank — ITORIS used to
       compute them per variant, and a custom size has no variant to read. Verified against
       order 124746 (plastic-flute-board-signs, 600 x 900, qty 10): _Standardized_Width 600,
       _Standardized_Height 900, _TOTAL_SQM 5.40. So on rigid board the standardised size IS
       the cut size (no bleed added) and _TOTAL_SQM is area x quantity. Both products on this
       snippet are rigid board, so the rule holds for both. Width / Height / Total (sqm) are
       the plain names these products carried before 22-Aug. */
    try{
      var vvD = state.custom
        ? (validCustom() ? {w:state.w,h:state.h} : null)
        : (function(){
            var p=(CFG.presets||[]).filter(function(x){return x.label===state.size;})[0];
            if(p&&p.w&&p.h) return {w:p.w,h:p.h};
            var m=/(\d+)\s*mm\s*W\s*x\s*(\d+)\s*mm\s*H/i.exec(state.size||'');
            return m?{w:parseInt(m[1],10),h:parseInt(m[2],10)}:null;
          })();
      if(vvD){
        var vvTot=((vvD.w*vvD.h)/1e6)*state.qty;
        props['Width']=String(vvD.w);
        props['Height']=String(vvD.h);
        props['Total (sqm)']=vvTot.toFixed(2);
        props['_Standardized_Width']=String(vvD.w);
        props['_Standardized_Height']=String(vvD.h);
        props['_TOTAL_SQM']=vvTot.toFixed(2);
        props['_PRODUCT_TITLE']=(CFG.title||document.title.split('|')[0].trim())+' ('+vvTot.toFixed(2)+')';
        props['_Standardized_Sided']=(state.printing===2?'Double':'Single');
      }
    }catch(e){}
    try{ props.__vvD=vvD; }catch(e){}
    return props;
  }

  // ADD TO CART (preview: adds base variant + line properties; server Function will set final price)
  addBtn.addEventListener('click',function(){
    var r=compute(); if(!r)return;
    addBtn.disabled=true; addBtn.textContent='Adding…';
    var props=vvBuildProps(r); var vvD=props.__vvD; delete props.__vvD;
    /* v2 multi-design: one cart line per design, the total quantity split as evenly as possible */
    var D=(V2&&state.designs>1)?state.designs:1, items=[];
    for(var dk=0;dk<D;dk++){ var qk=Math.floor(state.qty/D)+(dk<state.qty%D?1:0), pk={}; for(var pn in props) pk[pn]=props[pn];
      if(D>1){ pk['Design']=(dk+1)+' of '+D; try{ if(vvD){ var tk=((vvD.w*vvD.h)/1e6)*qk; pk['Total (sqm)']=tk.toFixed(2); pk['_TOTAL_SQM']=tk.toFixed(2); pk['_PRODUCT_TITLE']=(CFG.title||document.title.split('|')[0].trim())+' ('+tk.toFixed(2)+')'; } }catch(e){} }
      items.push({ id:CFG.variantId, quantity:qk, properties:pk }); }
    var body=D>1?{items:items}:items[0];
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
      .then(function(x){return x.json();})
      .then(function(j){ if(j&&(j.id||j.variant_id||(j.items&&j.items.length))){ window.location.href='/cart'; }
        else { addBtn.disabled=false; addBtn.textContent='Add to cart'; noteEl.textContent='Could not add to cart — '+((j&&j.description)||'try again'); } })
      .catch(function(){ addBtn.disabled=false; addBtn.textContent='Add to cart'; });
  });

  // BOOT: reveal our panel, hide the ITORIS DPO calculator UI on this product
  function killable(el){ return el && el!==root && !el.contains(root); }
  function hideEl(sel){ document.querySelectorAll(sel).forEach(function(el){ if(killable(el)&&el.style) el.style.setProperty('display','none','important'); }); }
  function hideElBox(sel){ document.querySelectorAll(sel).forEach(function(el){ if(killable(el)&&el.style) el.style.setProperty('display','none','important'); var box=el.closest('.product-form__input'); if(killable(box)) box.style.setProperty('display','none','important'); }); }
  function hideDpo(){
    hideEl('#options-wrapper');   // whole ITORIS DPO option block (Size/Eyelets/Thickness/Printed Sides/Cutting/Qty)
    ['.calculate-button','.view_pp_templates','.requiredesignstep','.dynamic-options','.product-custom-option',
     '.add-cart-wrapper','#AddToCart','.product-form__submit','.vq-dispatch-teaser','.required-delivery'].forEach(hideElBox);
    document.querySelectorAll('variant-selects .product-form__input, variant-selects .selector-wrapper').forEach(function(u){ if(killable(u)) u.style.setProperty('display','none','important'); });
  }
  var relocated=false;
  function relocate(){
    if(relocated) return;
    // sit exactly where the DPO options were: insert right before #options-wrapper (inside .wraper-form)
    var ow=document.querySelector('#options-wrapper');
    if(ow && ow.parentNode){ ow.parentNode.insertBefore(root, ow); relocated=true; return; }
    var anchor=document.querySelector('product-form, form[data-type="add-to-cart-form"], .product-form__buttons');
    if(anchor && anchor.parentNode){ anchor.parentNode.insertBefore(root, anchor); relocated=true; return; }
    var info=document.querySelector('.product__info-container, .product-single__meta, .product__info-wrapper');
    if(info){ info.appendChild(root); relocated=true; }
  }
  function show(){
    root.style.setProperty('display','block','important'); root.style.setProperty('visibility','visible','important');
    // if any ancestor got hidden, un-hide the chain up to the product container
    var p=root.parentElement;
    for(var i=0;i<8&&p;i++){ if(p.style && p.style.display==='none') p.style.removeProperty('display'); p=p.parentElement; }
  }
  /* Release-hardening (2026-10-06): a design journey returns to this page with ?cfg= (the configuration
     the customer set before designing — base64url JSON of this calculator's own line properties). Restore
     the selection from it so the calculator, the studio finish and the add-to-cart all carry that exact
     size/options again. Only values this calculator can represent are applied; prices are recomputed here. */
  function vvRestoreCfg(){
    try{
      var m=(location.search||'').match(/[?&]cfg=([A-Za-z0-9_-]{1,6000})/); if(!m) return;
      var b=m[1].replace(/-/g,'+').replace(/_/g,'/'); b+='==='.slice((b.length+3)%4);
      var o=JSON.parse(decodeURIComponent(escape(atob(b)))); if(!o||typeof o!=='object') return;
      var w=parseInt(o.Width,10)||0, h=parseInt(o.Height,10)||0, sz=String(o.Size||'');
      var preset=null; (CFG.presets||[]).forEach(function(p){ if(p.label===sz || (p.w&&p.h&&p.w===w&&p.h===h)) preset=p; });
      var cards=[].slice.call(root.querySelectorAll('[data-grp="size"] .vcorf-card'));
      if(preset){ var pw=preset.w||parseInt((preset.label.match(/(\d+)\s*mm\s*W/i)||[])[1],10), ph=preset.h||parseInt((preset.label.match(/x\s*(\d+)\s*mm\s*H/i)||[])[1],10), pc=cards.filter(function(c){ return new RegExp('^\\s*'+pw+'\\s*[×x]\\s*'+ph+'\\s*mm').test(c.textContent.trim()); })[0]; if(pc) pc.click(); }
      else if(w>0&&h>0){ customCard.click(); var wi=root.querySelector('[data-w]'), hi=root.querySelector('[data-h]'); if(wi){wi.value=w;} if(hi){hi.value=h;} state.w=w; state.h=h; }
      if(/^3\s*mm/i.test(String(o.Thickness||''))){ var tc=[].slice.call(root.querySelectorAll('[data-grp="thickness"] .vcorf-card')).filter(function(c){return /^3mm/.test(c.textContent.trim());})[0]; if(tc&&!tc.disabled) tc.click(); }
      if(/double/i.test(String(o.Printing||''))){ var dc=[].slice.call(root.querySelectorAll('[data-grp="printing"] .vcorf-card')).filter(function(c){return /double/i.test(c.textContent);})[0]; if(dc&&!dc.disabled) dc.click(); }
      if(/contour/i.test(String(o.Cutting||''))){ var cc=[].slice.call(root.querySelectorAll('[data-grp="cutting"] .vcorf-card')).filter(function(c){return /contour/i.test(c.textContent);})[0]; if(cc) cc.click(); }
      if(o.Eyelets){ for(var i=0;i<eyeSel.options.length;i++){ if(eyeSel.options[i].textContent===String(o.Eyelets)){ eyeSel.selectedIndex=i; state.eyelets=parseInt(eyeSel.value,10)||0; break; } } }
      var q=parseInt(o._vv_qty,10)||0; if(q>0){ state.qty=q; qtyInput.value=q; }
      recalc();
    }catch(e){}
  }
  function boot(){ relocate(); hideDpo(); show(); syncChips(); recalc(); vvRestoreCfg(); }
  boot();
  document.addEventListener('DOMContentLoaded', boot);
  var bn=0, biv=setInterval(function(){ boot(); if(++bn>30) clearInterval(biv); }, 350);
})();

